import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "toast-container position-fixed bottom-0 end-0 p-3 mb-1",
  style: {"z-index":"1090"}
}
const _hoisted_2 = { class: "toast-header" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["innerHTML"]

import { ref, onMounted, onUnmounted } from 'vue'
import { ToastManagerInstance, ToastMessage } from '../../common/toastManager'
import { ToastSeverity } from '../../common/toastManager'

// Компонент размещается на всех страницах и подписывается на тосты от других компонентов для их рендера

// Расширенный тип тоста
type ToastMessageWithId =
    ToastMessage
    // расширяем: ID для учета
    & { id: number }

// Локальный стейт для рендера

export default /*@__PURE__*/_defineComponent({
  __name: 'ToastContainer',
  setup(__props) {

const toasts = ref<ToastMessageWithId[]>([]);

const confing = {
    [ToastSeverity.info]: {
        text: 'text-secondary',
        border: 'border-secondary',
        title: 'Информация',
        bg: '',
    },
    [ToastSeverity.error]: {
        text: 'text-danger',
        border: 'border-danger',
        title: 'Ошибка',
        bg: 'text-bg-danger',
    },
    [ToastSeverity.warn]: {
        text: 'text-warning',
        border: 'border-warning',
        title: 'Внимание',
        bg: 'text-bg-warning',
    },
    [ToastSeverity.success]: {
        text: 'text-success',
        border: 'border-success',
        title: 'Успех',
        bg: 'text-bg-success',
    }
}

const getHeaderClass = (type: ToastSeverity) => confing[type]?.text || '';

const getBgClass = (type: ToastSeverity) => confing[type]?.bg || '';

const getDefaultTitle = (type: ToastSeverity) => confing[type]?.title || 'Уведомление';

const hideToast = (id: number) => {
    const index = toasts.value.findIndex(t => t.id === id)
    if (index > -1) {
        toasts.value.splice(index, 1)
    }
}

const hideOldest = () => {
    toasts.value.splice(0, 1)
}

// Основная функция рендеринга тоста
const show = (t: ToastMessage) => {
    const id = Date.now() + Math.random();

    const newToast =
    {
        id,
        ...t
    };

    toasts.value.push(newToast);

    if (t.autoHide != 0) {
        setTimeout(() => hideToast(id), t.autoHide || 5000);
    }

    // когда слишком много тостов
    if (toasts.value.length > 4) {
        hideOldest();
    }
}

onMounted(() => {
    // При подключении компонента - подписываемся на тосты - и рендерим каждый пришедший тост
    ToastManagerInstance.onToast(show);
});

onUnmounted(() => {
    ToastManagerInstance.unsub(show);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toasts.value, (toast) => {
      return (_openBlock(), _createElementBlock("div", {
        key: toast.id,
        class: _normalizeClass(["toast mb-2 show", getBgClass(toast.severity)]),
        role: "alert"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("strong", {
            class: _normalizeClass(["me-auto", getHeaderClass(toast.severity)])
          }, _toDisplayString(toast.title || getDefaultTitle(toast.severity)), 3),
          _createElementVNode("div", _hoisted_3, [
            (toast.actionLink)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: toast.actionLink,
                  class: "btn btn-primary btn-sm"
                }, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("i", { class: "bi bi-box-arrow-up-right" }, null, -1)
                ]))], 8, _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              onClick: () => hideToast(toast.id)
            }, null, 8, _hoisted_5)
          ])
        ]),
        _createElementVNode("div", {
          class: "toast-body",
          innerHTML: toast.body
        }, null, 8, _hoisted_6)
      ], 2))
    }), 128))
  ]))
}
}

})